const crossfadeDurationMs = 225;
const root = "_35sr8rtkcs";
const toggle = "_35st1uunyaj";
const transitionWrapper = "_35sthvcp";
const wrapper = "_35sw18lp12i";
const container = "_35sc1cs1nm1";
const chevron = "_35sc114j7gh";

export { chevron, container, crossfadeDurationMs, root, toggle, transitionWrapper, wrapper };
import "./container.facit.mobile.style.linaria.module.css";
//# sourceMappingURL=container.facit.mobile.style.js.map
